import Network from "../../../../infrastructure/js/modules/network";

export function fetchNests(data) {
  return Network.get('nests/search?businessId=');
}
